export default __webpack_public_path__ + "icon-pets.3c8f810953630cb7c80249ac4f1cbc60.svg";